import { NotificationTypes, type SafeAny } from '@/common/types';
import type { ScoreSetEventsData } from '@/modules/epoch/types';
import { axiosInstance } from '@/common/utils';

export const getEventsByType = async (
  { rootState, commit }: SafeAny,
  {
    studyId,
    eventTypes
  }: {
    studyId: string;
    eventTypes: string | string[];
  }
): Promise<ScoreSetEventsData> => {
  const url = `${rootState.env?.requestUrl.events}/studies/${studyId}`;
  try {
    const eventTypesParam = Array.isArray(eventTypes) ? eventTypes.join(',') : eventTypes;

    const eventsResponse = await axiosInstance.get<ScoreSetEventsData>(`${url}/events`, {
      params: { eventTypes: eventTypesParam }
    });

    return eventsResponse.data;
  } catch (error: SafeAny) {
    commit(
      'addNotification',
      {
        i18nTitle: 'errorGetEventsByType',
        type: NotificationTypes.Error,
        i18nDescription: error.message
      },
      { root: true }
    );
    throw error;
  }
};
